import { LevelType } from 'data/types';
import { isLevelConditioned } from 'utils/structure';

const BASE_LAYOUT_LEVEL_TYPE_ORDER: Record<string, number> = {
  level: 0,
  crawlspace: 1,
  basement: 2,
  attic: 3
};

function getLevelTypeOrder(level: LevelType): number {
  return BASE_LAYOUT_LEVEL_TYPE_ORDER[level.type] ?? Number.MAX_SAFE_INTEGER;
}

export function getBaseLayoutOrderedLevels(
  structure: LevelType[]
): LevelType[] {
  return structure
    .map((level, index) => ({
      level,
      index,
      order: getLevelTypeOrder(level)
    }))
    .sort((a, b) => {
      if (a.order !== b.order) {
        return a.order - b.order;
      }
      return a.index - b.index;
    })
    .map(({ level }) => level);
}

export function sortLevelsConditionedFirst(levels: LevelType[]): LevelType[] {
  return [
    ...levels.filter((level) => isLevelConditioned(level)),
    ...levels.filter((level) => !isLevelConditioned(level))
  ];
}
